import { hasFeature, hasRole, ROLES } from "./permissions";


export const menuItemsByPrivileges = (
  catalogEnabled = false,
  stockEnabled = false,
  purchaseEnabled = false,
  expenseEnabled = false,
  employeeEnabled = false,
  notificationEnabled = false,
  reportEnabled = false
) => {

const isAdmin = hasRole(ROLES.ADMIN);
const isSupplier = hasRole(ROLES.SUPPLIER);
const isAccountant = hasRole(ROLES.ACCOUNTANT);
const canInvoice = hasRole(ROLES.INVOICE);
const canQuote = hasRole(ROLES.QUOTE);
const canReporting = hasRole(ROLES.REPORTING);
const canPurchaseInvoice = hasRole(ROLES.PURCHASE_INVOICE);
const canNotification = hasRole(ROLES.NOTIFICATION);

const menu = [

  isAdmin && {
    title: "Admin",
    type: "header",
    hiddenOnCollapse: true,
  },

  isAdmin && {
    name: "Fournisseur",
    path: "/users/sales",
    icon: "fas fa-user",
  },

  isAdmin && {
    name: "Historique d'accès",
    path: "/users/access-history",
    icon: "fas fa-history",
  },

  isAdmin && {
    name: "Assistant IA",
    path: "/admin/assistant-analytics",
    icon: "fas fa-robot",
  },

  canReporting && {
    title: "Analytics",
    type: "header",
    hiddenOnCollapse: true,
  },

  canReporting && {
    name: "Dashboard",
    path: "/dashboard",
    icon: "fas fa-tachometer-alt",
  },

  canReporting && {
    name: "États de Paiement",
    path: "/payment-status",
    icon: "fas fa-file-invoice-dollar",
  },

  (isSupplier || canInvoice || canQuote) && {
    title: "Document",
    type: "header",
    hiddenOnCollapse: true,
  },



  buildVenteMenu(isSupplier, isAccountant, canInvoice, canQuote),

  purchaseEnabled && isSupplier && {
    name: "Achat",
    icon: "fas fa-shopping-bag",
    child: [
      canPurchaseInvoice && {
        name: "Factures Achats",
        path: "/document/purchase/invoice",
        icon: "fas fa-file-export",
      },
    ],
  },

  reportEnabled && isSupplier && {
    name: "Rapports",
    path: "/reports",
    icon: "fas fa-file-alt",
  },

  catalogEnabled && isSupplier && {
    title: "Catalogue",
    type: "header",
    hiddenOnCollapse: true,
  },

  catalogEnabled && isSupplier && {
    name: "Articles",
    path: "/catalog",
    icon: "fas fa-boxes",
  },

  catalogEnabled && isSupplier && {
    name: "Catégories",
    path: "/catalog/categories",
    icon: "fas fa-tags",
  },

  catalogEnabled && isSupplier && {
    name: "Sous-catégories",
    path: "/catalog/subcategories",
    icon: "fas fa-sitemap",
  },

  stockEnabled && isSupplier && {
    title: "Stock",
    type: "header",
    hiddenOnCollapse: true,
  },

  stockEnabled && isSupplier &&{
    name: "État du stock",
    path: "/stock/status",
    icon: "fas fa-boxes",
  },
  stockEnabled && isSupplier &&{
    name: "Dépôts",
    path: "/stock/warehouses",
    icon: "fas fa-warehouse",
  },
  stockEnabled && isSupplier &&{
    name: "Inventaires",
    path: "/stock/inventories",
    icon: "fas fa-clipboard-check",
  },


      // User Management Section
  isSupplier &&{ title: "Clients & Fournisseurs", type: "header", hiddenOnCollapse: true },


  hasFeature("ecommerce") && isSupplier && {
    name: "Clients",
    path: "/users/customer",
    icon: "fas fa-user-tie",
  },

  purchaseEnabled && hasFeature("ecommerce") && isSupplier && {
    name: "Fournisseurs Achats",
    path: "/users/purchasing-suppliers",
    icon: "fas fa-industry",
  },

  (expenseEnabled || employeeEnabled) && isSupplier && {
    title: "Charges",
    type: "header",
    hiddenOnCollapse: true
  },

  employeeEnabled && isSupplier && {
    name: "Employés",
    path: "/employees",
    icon: "fas fa-users",
  },

  employeeEnabled && isSupplier && {
    name: "Avances sur salaire",
    path: "/salary-advances",
    icon: "fas fa-money-check-alt",
  },

  employeeEnabled && isSupplier && {
    name: "Bulletins de paie",
    path: "/payroll",
    icon: "fas fa-file-invoice-dollar",
  },

  expenseEnabled && isSupplier && {
    name: "Dépenses",
    path: "/expenses",
    icon: "fas fa-receipt", 
  },

  notificationEnabled && (isSupplier || canNotification) && {
    title: "Notifications",
    type: "header",
    hiddenOnCollapse: true
  },

  notificationEnabled && (isSupplier || canNotification) && {
    name: "Agenda & Alertes",
    path: "/agenda/alerts",
    icon: "far fa-bell",
  },

  hasFeature("partenaires") && isAdmin && {
    name: "Partenaires",
    path: "/users/partner",
    icon: "fas fa-handshake",
  },

  isSupplier && { title: "Configuration", type: "header", hiddenOnCollapse: true },

  hasFeature("ecommerce") && isSupplier && {
    name: "Compteur Pièces",
    path: "/piece-counter",
    icon: "fas fa-cog",
  },

  hasFeature("ecommerce") && isSupplier && {
    name: "Profile",
    path: "/invoice-profile",
    icon: "fas fa-user-circle",
  },

  isSupplier && {
    name: "Aperçu Documents",
    path: "/configuration/documents",
    icon: "fas fa-file-alt",
  },

  isSupplier && {
    name: "Facturation électronique",
    path: "/configuration/elfatoora",
    icon: "fas fa-file-invoice",
  },

  notificationEnabled && (isSupplier || canNotification) && {
    name: "SMTP",
    path: "/configuration/smtp",
    icon: "fas fa-envelope-open-text",
  },




  { title: "Déconnecter", type: "header", hiddenOnCollapse: true },

  {
    name: "Se déconnecter",
    action: "logout",
    link: "/logout",
    icon: "fas fa-power-off",
  },
];
  // Filter out false/null child
  return menu
    .map((section) => {
      if (section && section.child) {
        const child = section.child.filter(Boolean);
        return child.length ? { ...section, child } : null;
      }
      return section;
    })
    .filter(Boolean);
};

const filterMenu = (items) => items.filter(Boolean);

const buildVenteMenu = (isSupplier, isAccountant, canInvoice, canQuote) => {
  const children = filterMenu([
    canInvoice && hasFeature("work_tracking_sheet") && {
      name: "Liste des Fiches",
      path: "/document/fiche-suivi",
      icon: "fas fa-clipboard-list",
    },

    canQuote && {
      name: "Liste des Offres",
      path: "/document/quote",
      icon: "fas fa-list",
    },

    (canInvoice || isAccountant) && {
      name: "Factures Vente",
      path: "/document/invoice",
      icon: "fas fa-file-invoice-dollar",
    },

    (canInvoice || isAccountant) && {
      name: "Avoirs",
      path: "/document/credit-note",
      icon: "fas fa-file-invoice-dollar",
    },

    canInvoice && {
      name: "Importation Factures",
      path: "/document/invoice/import",
      icon: "fas fa-file-csv",
    },
  ]);

  // 🔥 auto flatten if only 1 item
  return children.length === 1
    ? children[0]
    : {
        name: "Vente",
        icon: "fas fa-cash-register",
        child: children,
      };
};
